/*农资业务数据管理系统*/

/*主容器文件*/
const nzywsjgl_ = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/nzywsjgl_systems_main");

/*分销集采子系统*/
const nzywsjgl__fxcjzxt_ = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/fxcjzxt/fxcjzxt_main");
// 需求记录
const nzywsjgl_gylglzxt_requirementRecord = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/fxcjzxt/requirementRecord/main.vue");
// 预约记录
const nzywsjgl_gylglzxt_appointmentRecord = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/fxcjzxt/appointmentRecord/main.vue");
// 订单记录
const nzywsjgl_gylglzxt_onlineOrder = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/fxcjzxt/onlineOrder/main.vue");

/*供应链管理子系统*/
const nzywsjgl_gylglzxt_ = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/gylglzxt_main");
/*供应商主体管理*/
const nzywsjgl_gylglzxt_gysztgl = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/gysztgl/gysztgl_main");
// 单品录入
const nzywsjgl_gylglzxt_skuManage = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/productEntry/skuManage/index");
// 套餐录入
const nzywsjgl_gylglzxt_setmealManage = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/productEntry/setmealManage/index");
// 单品发布
const nzywsjgl_gylglzxt_goodLaunch = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/productLaunch/goodLaunch/index");
// 套餐发布
const nzywsjgl_gylglzxt_combineLaunch = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/productLaunch/combineLaunch/index");
// 订单明细
const nzywsjgl_gylglzxt_orderList = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/orderManage/orderList/index");
// 发货管理
const nzywsjgl_gylglzxt_shipmentManage = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/orderManage/shipmentManage/index");
// 退货管理
const nzywsjgl_gylglzxt_returnManage = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/orderManage/returnManage/index");
// 农资字典管理
const nzywsjgl_gylglzxt_dictionary = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/dictionary/main");
// 商城目录配置
const nzywsjgl_gylglzxt_productCategory = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/dictionary/productCategory/productCategory");
// 产品品牌配置
const nzywsjgl_gylglzxt_productBrand = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/gylglzxt/dictionary/productBrand/productBrand");
// 终端销售管理
const nzywsjgl_zdxsgl_ = () => import("../../../studio/sub_systems/nzywsjgl_systems/zdxsglzxt/zdxsgl_main.vue")
const nzywsjgl_zdxsgl_list = () => import("../../../studio/sub_systems/nzywsjgl_systems/zdxsglzxt/zdxsgl/list.vue")

/*分布式仓储管理子系统*/
const nzywsjgl__fbsccglzxt_ = () =>  import("../../../studio/sub_systems/nzywsjgl_systems/fbsccglzxt/fbsccglzxt_main");


export default [
  {
    path: '/nzywsjgl',
    name: '农资业务数据管理系统',
    redirect: '/nzywsjgl/gylglzxt',
    component: nzywsjgl_,
    children: [
      {
        path: '/nzywsjgl/fxcjzxt',
        redirect: '/nzywsjgl/fxcjzxt/requirementRecord',
        name: '分销集采子系统',
        component: nzywsjgl__fxcjzxt_,
        children:[
          {
            path: '/nzywsjgl/fxcjzxt/requirementRecord',
            name: '需求记录',
            component: nzywsjgl_gylglzxt_requirementRecord ,
          },
          {
            path: '/nzywsjgl/fxcjzxt/appointmentRecord',
            name: '预约记录',
            component: nzywsjgl_gylglzxt_appointmentRecord ,
          },
          {
            path: '/nzywsjgl/fxcjzxt/onlineOrder',
            name: '订单记录',
            component: nzywsjgl_gylglzxt_onlineOrder ,
          },
        ]
      },
      {
        path: '/nzywsjgl/gylglzxt',
        redirect: '/nzywsjgl/gylglzxt/gysztgl',
        name: '供应链管理子系统',
        component: nzywsjgl_gylglzxt_,
        children:[
          {
            path: '/nzywsjgl/gylglzxt/gysztgl',
            name: '供应商主体管理',
            component: nzywsjgl_gylglzxt_gysztgl ,
          },
          {
            path: '/nzywsjgl/gylglzxt/skuManage',
            name: '单品录入',
            component: nzywsjgl_gylglzxt_skuManage ,
          },
          {
            path: '/nzywsjgl/gylglzxt/setmealManage',
            name: '套餐录入',
            component: nzywsjgl_gylglzxt_setmealManage ,
          },
          {
            path: '/nzywsjgl/gylglzxt/goodLaunch',
            name: '单品发布',
            component: nzywsjgl_gylglzxt_goodLaunch ,
          },
          {
            path: '/nzywsjgl/gylglzxt/combineLaunch',
            name: '套餐发布',
            component: nzywsjgl_gylglzxt_combineLaunch ,
          },
          {
            path: '/nzywsjgl/gylglzxt/orderList',
            name: '订单明细',
            component: nzywsjgl_gylglzxt_orderList ,
          },
          {
            path: '/nzywsjgl/gylglzxt/shipmentManage',
            name: '发货管理',
            component: nzywsjgl_gylglzxt_shipmentManage ,
          },
          {
            path: '/nzywsjgl/gylglzxt/returnManage',
            name: '退货管理',
            component: nzywsjgl_gylglzxt_returnManage ,
          },
          {
            path: '/nzywsjgl/gylglzxt/dictionary',
            name: '农资字典管理',
            component: nzywsjgl_gylglzxt_dictionary ,
          },
          {
            path: '/nzywsjgl/gylglzxt/productCategory',
            name: '商城目录配置',
            component: nzywsjgl_gylglzxt_productCategory ,
          },
          {
            path: '/nzywsjgl/gylglzxt/productBrand',
            name: '产品品牌配置',
            component: nzywsjgl_gylglzxt_productBrand ,
          },
        ]
      },
      {
        path: '/nzywsjgl/fbsccglzxt',
        name: '分布式仓储管理子系统',
        component: nzywsjgl__fbsccglzxt_,
      },
      {
        path: '/nzywsjgl',
        name: '终端销售管理子系统',
        redirect: '/nzywsjgl/zdxsgl',
        component: nzywsjgl_zdxsgl_,
        children: [
          {
            path: '/nzywsjgl/zdxsgl',
            name: '产品品牌配置',
            component: nzywsjgl_zdxsgl_list ,
          },
        ]
      }

    ]
  }
]








// WEBPACK FOOTER //
// ./src/router/modules/nzywsjgl/nzywsjgl_system_page.js